caseStudyHandler = {
    $panelCaseStudies = $('.panel-case-studies'),
    $gridCaseStudies = $('.grid-case-studies'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,

    reAnimateObj = function(){
        this.$panelCaseStudies.each(function(){
            var $titleText = $(this).find('.title-text');

            animateHandler.animateScroll($titleText, 2, true);
        })
    },

    init = function(){
        var self = this;
        this.isOnLoad = true;
        
        this.$panelCaseStudies.each(function(){
            var $titleText = $(this).find('.title-text');
            var $gridItem = $(this).find('.grid-item');

            animateHandler.animateScroll($titleText, 2);
            animateHandler.animateParallax(self.$gridCaseStudies);
            
            $gridItem.each(function(i, div){
                if ($(this).hasClass('is-mobile') === false) {
                    animateHandler.animateParallax($(this), (i != 0), (i == 0));
                }
            })
        })

        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        self.reAnimateObj();
                        self.lastWindowWidth = windowWidth;
                    }
                }
            }, 25);
        });

    }
}